import { TLBounds, Utils } from '@tldraw/core'
import {SessionType, TldrawPatch, TldrawCommand, WhiteboardStore, ToolStatus} from '@modules/whiteboard'
import {BaseSession} from '@modules/whiteboard/sessions/BaseSession'
import {action, computed, observable } from '@api'

export class BrushSession extends BaseSession {
  type = SessionType.Brush
  @observable initialSelectedIds: Array<string>
  @computed get initialSelectedIdsSet() { return new Set<string>(this.initialSelectedIds)}

  @observable shapesToTest: Array<{
    id: string
    bounds: TLBounds
    selectId: string
  }>

  constructor(app: WhiteboardStore) {
    super(app)
    this.initialSelectedIds = app.selectedIds.slice()
    this.shapesToTest = app.shapes
      .filter(
        (shape) =>
          !(
            shape.isLocked ||
            shape.isHidden ||
            shape.parentId !== app.currentPageId ||
            this.initialSelectedIdsSet.has(shape.id) ||
            this.initialSelectedIdsSet.has(shape.parentId)
          )
      )
      .map((shape) => ({
        id: shape.id,
        bounds: app.shapeUtilFor(shape).getBounds(shape),
        selectId: shape.id, // Comment is in original code too! TLDR.getTopParentId(data, shape.id, currentPageId),
      }))
  }

  @action start = (): TldrawPatch | undefined => {
    this.status = 'brushing'
    return void null
  }

  @computed get brush() {
    // Create a bounding box between the origin and the new point
    const {app: {originPoint, currentPoint}} = this
    return Utils.getBoundsFromPoints([originPoint, currentPoint])
  }

  @action update = (): TldrawPatch | undefined => {
    const {
      shapesToTest,
      app, app: { myPageState, appState, metaKey, shapeUtilFor, getShape }, brush
    } = this

    // Find ids of brushed/bounded shapes
    const hits = new Set<string>(),
      selectedIds = new Set<string>(this.initialSelectedIds)

    shapesToTest.forEach(({ id, selectId }) => {
      if (!hits.has(selectId)) {
        const shape = getShape(id), util = shapeUtilFor(shape)

        if (metaKey ? Utils.boundsContain(brush, util.getBounds(shape)) : util.hitTestBounds(shape, brush)) {
          hits.add(selectId)

          // When brushing a shape, select its top group parent.
          if (!selectedIds.has(selectId)) {
            selectedIds.add(selectId)
          }
        } else if (selectedIds.has(selectId)) {
          selectedIds.delete(selectId)
        }
      }
    })

    appState.brush = brush
    myPageState.selectedIds = Array.from(selectedIds.values())

    return undefined
  }

  @action cancel = (): TldrawPatch | undefined => {
    _.merge(this.app.appState, { brush: null, selectedIds: this.initialSelectedIds})
    return undefined
  }

  @action complete = (): TldrawPatch | TldrawCommand | undefined => {
    this.app.appState.brush = null

    return undefined
  }
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/sessions/BrushSession/BrushSession.ts